import Progress from './src/progress.mjs';
export { progressProps } from './src/progress2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElProgress = withInstall(Progress);

export { ElProgress, ElProgress as default };
//# sourceMappingURL=index.mjs.map
